import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import Select from 'react-select'
import { KeyValuePairs, InputContainer, If } from 'components/ideal-core-ui'
import s from './AddProposalModal.scss'
import { PaginatedSelect } from 'components/common/PaginatedSelect'
import { toDealsSelect } from 'components/Deals/serializers'

const AddProposalModal = ({
  showAddProposalModal,
  toggleAddProposalModal,
  createProposal,
  dealName,
  dealCompanies,
  changeProposalProperty,
  uploadFile,
  showProposalError,
  deal,
  proposal
}) => {
  const pairs = [
    {
      key: '* Proposal Name',
      value: (
        <InputContainer
          type="text"
          className={s.nameInput}
          placeholder="Enter Proposal Name"
          cb={value => changeProposalProperty(value, 'name')}
          cy="proposal_name"
        />
      )
    },
    {
      key: '* Opportunity',
      value: deal.value ? (
        <Select isDisabled={deal.value} value={deal} />
      ) : (
        <PaginatedSelect
          url="/v1/deals"
          onChange={value => changeProposalProperty(value, 'deal')}
          serializer={toDealsSelect}
          value={proposal.deal}
        />
      )
    },
    {
      key: '* Client',
      value: (
        <Select
          onChange={value => changeProposalProperty(value.value, 'company')}
          options={dealCompanies}
          id="cy_client_select"
        />
      )
    },
    {
      key: '* Upload File',
      value: (
        <input type="file" onChange={uploadFile} className={s.fileInput} data-cy="upload_btn" />
      )
    }
  ]

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showAddProposalModal}
        toggle={toggleAddProposalModal}
        className={s.proposalModal}
        size="lg"
        data-cy="add_proposal_from_pdf_modal"
      >
        <ModalHeader toggle={toggleAddProposalModal} className={s.modalHeader}>
          Add New Proposal
        </ModalHeader>
        <ModalBody>
          <If condition={dealName}>
            <p>You are adding a proposal for {dealName}</p>
          </If>
          {showProposalError && <p className={s.error}>All required fields must have a value</p>}
          <KeyValuePairs pairs={pairs} />
        </ModalBody>
        <ModalFooter>
          <Button className={s.saveBtn} onClick={createProposal} data-cy="save_btn">
            Save
          </Button>
          <Button color="secondary" onClick={toggleAddProposalModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default AddProposalModal
